/*
    CABINET / transfers
 */
jQuery(function ($) {
    $(document).ready(function () {
        $('#cabinet-transfers .select-delivery input').bind('click', function (e) {
            let type = $(this).val();
            $('#cabinet-transfers .noall').hide();
            $('#cabinet-transfers legend.' + type + '').show();
            $('#cabinet-transfers .metro.' + type + '').show();
            $('#cabinet-transfers .address.' + type + '').show();
        });

        $("#transfers").validate({
            errorElement: 'span',
            errorClass: 'help-block',
            highlight: function (element, errorClass) {
                $(element).parent().addClass('error');
            }, unhighlight: function (element, errorClass) {
                $(element).parent().removeClass('error');
            },
            rules: {
                name: {
                    required: true,
                    minlength: 5
                },
                phone: {
                    required: true,
                    pattern: /^[0-9]{10}$/
                },
                adress: {
                    required: true,
                    minlength: 5
                },
            },
            messages: {
                name: {
                    required: "Введите имя",
                    minlength: "Слишком короткое"
                },
                phone: {
                    required: "Введите Ваш контактный номер",
                    pattern: "Введите только цифры. В формате 1112223344"
                },
                adress: {
                    required: "Укажите адрес для доставки или адрес пункта выдачи",
                    minlength: "Мало букв"
                },
            }
        });
    });
});